// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format12 } from '../../constants';

import { format5 } from '../../constants';

/** Lebanon */
const LB: PhoneNumberData = [961, 'LB', 7, format12, 8, format5];

export default LB;
